// actionTypes.js

export const FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA = 'FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA';
export const FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_SUCCESS = 'FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_SUCCESS';
export const FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_FAILURE = 'FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_FAILURE';
export const FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_API_CALL = 'FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_API_CALL';
export const FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_EXPORT_SUCCESS = 'FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA_EXPORT_SUCCESS';

